// Agecheck Modal
function checkAgeConfirmation() {
    var ageConfirmed = localStorage.getItem("ageConfirmed") === "true";
    var lastConfirmationTime = localStorage.getItem("lastConfirmationTime");

    // 24時間以上経過しているかをチェック
    if (!ageConfirmed || !lastConfirmationTime || Date.now() - parseInt(lastConfirmationTime) > 24 * 60 * 60 * 1000) {
        var ageModal = document.getElementById("ageModal");
        if (ageModal) {
            ageModal.style.display = "block";
        }
    }
}

window.onload = function() {
    checkAgeConfirmation();

    // YES
    var yesButton = document.getElementById("yesButton");
    if (yesButton) {
        yesButton.onclick = function() {
            localStorage.setItem("ageConfirmed", "true");
            localStorage.setItem("lastConfirmationTime", Date.now().toString()); // 現在時刻を保存
            var ageModal = document.getElementById("ageModal");
            if (ageModal) {
                ageModal.style.display = "none";
            }
        };
    }

    // NO
    var noButton = document.getElementById("noButton");
    if (noButton) {
        noButton.onclick = function() {
            history.back();
        };
    }
};
